<template>
    <div class="manage">
        <span style="font-weight: bold; font-size: 26px; color: red;">SIM卡过期时间</span>
        <el-tabs v-model="activeTab" @tab-click="handleClick" type="border-card">
            <el-tab-pane v-for="(exp_date, idx) in expiryDate" :key="idx" :label="exp_date" :name="exp_date">
                <el-table :data="simCardsData" style="width: 100%; height: 90%;" :stripe="true">
                    <el-table-column label="序号" prop="index" align="center" width="50px"></el-table-column>
                    <el-table-column label="MSISDN" prop="msisdn" align="center"></el-table-column>
                    <el-table-column label="ICCID" prop="iccid" align="center" width="200px"></el-table-column>
                    <el-table-column label="IMSI" prop="imsi" align="center"></el-table-column>
                    <el-table-column label="运营商" prop="operator" align="center" width="100px"></el-table-column>
                    <el-table-column label="激活日期" prop="cu_act_date" align="center" width="200px"></el-table-column>
                    <el-table-column label="到期日期" prop="cu_edate" align="center" width="200px"></el-table-column>
                    <el-table-column label="剩余流量" prop="data_remain" align="center" width="100px">
                        <template slot-scope="scope">
                            {{ scope.row.data_remain }} MB
                        </template>
                    </el-table-column>
                    <el-table-column label="卡状态" prop="sim_status" align="center"></el-table-column>
                </el-table>
                
            </el-tab-pane>
        </el-tabs>
        <div style="text-align:center">
			<el-pagination layout="sizes, prev, pager, next" 
			:total="pageTotal" 
			:page-sizes="[10, 20, 30, 40]"
			:page-size="pageSize" 
			:current-page.sync="currentPage" 
			@current-change="handleCurrentChange"
			@size-change="handleSizeChange">
			</el-pagination>
		</div>
        
    </div>


</template>

<script>
import Cookie from 'js-cookie'
import { convertSimStatus, formatDate, loginTaoyuanTech, getSimCardGroups, getExpirySimCards, getSimCardInfo } from '../api'

export default {
    data() {
        return {
            simCardGroups: [{
                down: 0,
                expiry: [],
                silence: 0,
                test: 0,
                total: 0,
                using: 0
            }],
            activeTab: '',  // 初始选中第一个
            expiryDate: [],
            simCardsData: [],

            currentPage: 1,  // 当前页码
            pageSize: 10,  // 每页显示的条数
            pageTotal: 0  // 总条数
        }
    },
    mounted() {
        // login into taoyuan-tech and then save token to cookie
        try {
            // if (Cookie.get('taoyuan_tech_cookies')) {
            //     // Cookie.remove('taoyuan_tech_cookies');
            //     console.log('Already logged in, token:', Cookie.get('taoyuan_tech_cookies'));
                
            //     this.loadData();
            // } else {
            
            loginTaoyuanTech().then(res => {
                console.log('Login response:', res.data.code);
                // 检查登录结果
                if (res.data.code === 200 && res.data.data.session) {
                    console.log('登录taoyuan-tech成功, token:', res.data.data.session);
                    // You can save the token to cookie or localStorage here
                    Cookie.set('taoyuan_tech_cookies', res.data.data.session);

                    this.loadData();
                } else {
                    // throw new Error('登录失败，请检查用户名和密码');
                    console.error('登录失败，请检查用户名和密码:', res.message);
                }
            });

        } catch (error) {
            console.error('登录taoyuan-tech异常:', error);
        }
    },
    methods: {
        convertTabIdxToDate(tabIndex) {
            const today = new Date();
            // 构造新的日期：当前年、当前月 + tabIndex、日期为 1 号
            const targetDate = new Date(today.getFullYear(), today.getMonth() + Number(tabIndex), 1);
            console.log('Current date:', today.getFullYear(), today.getMonth() + Number(tabIndex), tabIndex);
            console.log('Target date:', targetDate);

            const year = targetDate.getFullYear();
            const month = (targetDate.getMonth() + 1).toString().padStart(2, '0'); // 月份补 0

            return `${year}${month}`; // 返回 YYYYmm 格式
        },
        handleClick(tab, event) {
            console.log('Tab clicked:', tab);
            // 加载选中分组的SIM卡数据
            console.log('查询过期月份:', tab.label);
            this.activeTab = tab.label;  // 更新当前选中的标签
            this.loadTabData();
            // getExpirySimCards(tab.label, 1, 10).then(res => {
            //     console.log('Sim cards for group:', res.data);
            //     this.simCardsData = res.data.data;
            //     // 为每个SIM卡添加序号
            //     this.simCardsData.forEach((item, index) => {
            //         item.index = index + 1;
            //     });
            // }).catch(error => {
            //     console.error('Error fetching sim cards:', error);
            // });
        },
        loadData() {
            // 加载数据
            getSimCardGroups().then(res => {
                console.log('Sim card groups:', res.data);
                this.simCardGroups = res.data.data;
                for (let exp in [0, 1, 2]) {
                    // 将分组的过期日期转换为 YYYYmm 格式
                    this.expiryDate.push(this.convertTabIdxToDate(exp));
                }
                this.activeTab = this.expiryDate[0];  // 初始选中第一个
                // 默认选中第一个分组
                this.loadTabData();
            }).catch(error => {
                console.error('Error fetching sim card groups:', error);
            });
        },
        loadTabData() {
            if (this.expiryDate.length > 0) {
                getExpirySimCards(this.activeTab, this.currentPage, this.pageSize).then(res => {
                    console.log('查询过期月份2:', this.activeTab);
                    console.log('本月过期SIM卡:', res.data);
                    let _data = res.data.data || {}
                    this.simCardsData = _data.sims || [];
                    this.pageTotal = _data.count || 0;  // 更新总条数
                    // 为每个SIM卡添加序号
                    this.simCardsData.forEach((item, index) => {
                        item.index = index + 1;
                        item.operator = item.operator === 0 ? '中国移动' : (item.carrier === 1 ? '中国联通' : '中国电信');
                        item.cu_act_date = formatDate(item.cu_act_date);
                        item.cu_edate = formatDate(item.cu_edate);
                        item.sim_status = convertSimStatus(item.sim_status);
                    });
                }).catch(error => {
                    console.error('获取本月过期SIM卡失败:', error);
                });
            }
        },
        handleCurrentChange(val) {
            console.log('当前页码:', val);
            this.currentPage = val;
            // 重新加载当前页的数据
            this.loadTabData();
        },
        handleSizeChange(val) {
            console.log('每页条数:', val);
            this.pageSize = val;
            // 重新加载数据
            this.loadTabData();
        },
        handleSearch() {
            // 搜索功能可以在这里实现
            console.log('搜索功能尚未实现');
        },
    }
}

</script>